import { useMediaQuery } from "usehooks-ts";

export const breakpoints = {
  xs: "400px",
  sm: "600px",
  md: "900px",
  lg: "1200px",
  xl: "1536px",
};

type BreakpointKey = keyof typeof breakpoints;

export function useBreakpoint<K extends BreakpointKey>(
  breakpointKey: K,
  direction: "up" | "down" = "up"
) {
  return useMediaQuery(
    direction === "up"
      ? `(min-width: ${breakpoints[breakpointKey]})`
      : `(max-width: ${breakpoints[breakpointKey]})`
  );
}
